import script from "./PatientNoticeBoard.vue?vue&type=script&setup=true&lang=ts"
export * from "./PatientNoticeBoard.vue?vue&type=script&setup=true&lang=ts"

import "./PatientNoticeBoard.vue?vue&type=style&index=0&id=e80badb4&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e80badb4"]])

export default __exports__